import styles from './main.module.css';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';

const Done = () => {

    return (
        <>
        <header className={`fixed-top ${styles.navbarRegala}`}>
            <nav className={`navbar navbar-expand `} aria-label="Eighth navbar example">
                <div className={`container d-flex flex-column flex-lg-row ${styles.navbarContainer}`}>
                    <a className={`navbar-brand ${styles.navbarBrand}`} href="/">
                        Hagamos Cosas Juntos
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
                    aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse ${styles.collapse} navbar-collapse`}>
                        <ul className="navbar-nav ml-lg-auto">
                            <li className={`nav-item ${styles.navbarBtn}`}>
                                <a className="nav-link" href="/#">Inicio</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <section className={`container ${styles.sectionDone}`}>
            <div className="row">
                <div className="col-md-12 text-center">
                    <h3>4.- Tu suscripción para regalar ha sido enviada</h3>
                    <p className={`${styles.doneText}`}>Felicitaciones, tu regalo ha sido enviado a su receptor.
                    <br /><br /><strong>Gracias por regalar Chungungo</strong>
                    <br /><br />¿Dudas o Problemas?
                    <br /><br />Escríbenos a <a href="">contacto@chungungo.com</a></p>
                </div>

            </div>
        </section>


        <footer className={`${styles.footer}`}>
            <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                <ul className="nav justify-content-center">
                    <li className="nav-item">
                    <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/about">Acerca de</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                    </li>
                </ul>
                <ul className="nav justify-content-center mb-5">
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                    </li>
                </ul>
                <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
                </div>
            </div>
            </div>
            <div className={`${styles.unicef}`}>
                <img src={unicefLogo} alt="Patrocinio Unicef" />
            </div>
        </footer>
        
        </>


    )

}

export default Done;